import { useNavigate } from 'react-router-dom';

import { Path, setPath } from 'src/store/slices/user';
import { useAppDispatch } from 'src/utils';

import { ContentLayout } from '../components/content-layout';
import { SelectionList } from '../components/selection-list';
import { useCameraIdScanAccess } from './check-in/scan/use-camera-id-scan-access';

export const SelectPath = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // Fails closed, so the path is absent unless both the rollout flag and the location feature are on.
  const isCameraIdScanEnabled = useCameraIdScanAccess();

  const handleMethodSelection = (method: { value: Path }) => {
    dispatch(setPath(method.value));
    navigate(`/registers`);
  };

  return (
    <ContentLayout>
      <SelectionList
        key='key'
        list={[
          { key: Path.Curbside, value: Path.Curbside },
          { key: Path.Delivery, value: Path.Delivery },
          ...(isCameraIdScanEnabled ? [{ key: Path.CheckIn, value: Path.CheckIn }] : []),
        ]}
        name='Use'
        value='value'
        onGoBack={() => navigate('/locations')}
        onSelection={handleMethodSelection}
      />
    </ContentLayout>
  );
};
